export const getEventInformation = async ({ eventId, inviteeId }) => {
  try {
    const response = await fetch(`/event/${eventId}/invitee/${inviteeId}`)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error fetching scheduled event:", error)
    return { error: error.message }
  }
}
  